import React from 'react'
import {
  Section,
  Container,
  Heading,
  Grid,
  StatCard,
  StatTitle,
  StatValue,
} from '../styles/TeamAccoladesStyles'

const TeamAccolades = () => {
    const stats = [
        { id: 1, name: 'Realtors Nationwide', value: 'Top 1.35%' },
        { id: 2, name: 'Sales in 2024', value: '$130M+' },
        { id: 3, name: 'Average Sales Price in 2024', value: '$2.8M+' },
        { id: 4, name: 'Total Sales', value: '$500M+' },
      ]
  return (
    <Section>
      <Container>
        <Heading>Team Accolades</Heading>
        <Grid>
          {stats.map((stat) => (
            <StatCard key={stat.id}>
              <StatTitle>{stat.name}</StatTitle>
              <StatValue>{stat.value}</StatValue>
            </StatCard>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default TeamAccolades